<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <div class="my-4 display-1">Podaci o korisniku</div>
        <v-text-field v-model="user.name" label="Ime" required></v-text-field>
        <v-text-field v-model="user.address" label="Adresa" required></v-text-field>
        <v-text-field v-model="user.phone" label="Telefon" required></v-text-field>
        <v-switch v-if="user.isCourier" v-model="online" label="Na poslu"></v-switch>
        <!-- <v-switch v-model="user.roles" label="Radnja" value="store"></v-switch>
        <v-switch v-model="user.roles" label="Dostavljač" value="courier"></v-switch> -->
        <v-btn class="primary" large block @click="submit" :loading="loading">sačuvaj</v-btn>
        <v-alert v-model="success" type="success">Podaci su sačuvani</v-alert>
        <v-alert v-model="error" type="error">Došlo je do greške, pokušajte ponovo ili kontaktirajte podršku</v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import auth from '@/services/authService.js'
import userService from '@/services/userService.js'
import cordovaService from '@/services/cordovaService.js'

export default {
  data () {
    return {
      user: auth.getCurrentUser(),
      loading: false,
      success: false,
      error: false
    }
  },
  methods: {
    submit () {
      this.loading = true
      userService.updateCurrentUser(this.user).then((response) => {
        this.loading = false
        this.success = true
      }, (error) => {
        console.log(error)
        this.loading = false
        this.error = true
      })
    }
  },
  computed: {
    online: {
      get () {
        return this.user.online === 1
      },
      set (online) {
        if (online) {
          this.user.online = 1
          cordovaService.unsubscribeToTopics()
        } else {
          this.user.online = 0
          cordovaService.unsubscribeToTopics()
        }
        userService.updateOnlineStatus(online)
      }
    }
  }
}
</script>
